import React from 'react'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import { ProfileTabs, ProfileTabsType } from 'shared/models/Profile'

import { ReactComponent as BetsHistorySVG } from '../img/bethistory.svg'
import { ReactComponent as ChangePasswordSVG } from '../img/changePassword.svg'
import { ReactComponent as LogOutSVG } from '../img/logout.svg'
import { ReactComponent as ProfileSVG } from '../img/profile.svg'
import { ReactComponent as SlotsHistorySVG } from '../img/slotshistory.svg'
import { ReactComponent as TransactionVG } from '../img/transactions.svg'
import { ReactComponent as TransferBonusSVG } from '../img/transferbonus.svg'
const PersonalInformation = React.lazy(
  () => import('components/ProfileComponents/PersonalInformation/PersonalInformation'),
)
const ExchangeBonusToBalance = React.lazy(
  () => import('components/ProfileComponents/Bonuses/ExchangeBonusBalance/ExchangeBonusBalance'),
)
const Transactions = React.lazy(() => import('components/ProfileComponents/Transactions/Transactions'))
const SlotsHistory = React.lazy(() => import('pages/ProfilePage/SlotsHistory/SlotsHistory'))
const ProfileMenu = React.lazy(() => import('components/Profile/ProfileMenu/ProfileMenu'))
const ChangePassword = React.lazy(() => import('components/ProfileComponents/ChangePassword/ChangePassword'))
const BetsHistory = React.lazy(() => import('components/ProfileComponents/BetHistory/BetHistory'))
export interface IProfileMenuLinks {
  title: ProfileTabsType
  route?: string
  Component?: React.LazyExoticComponent<React.FC>
  modalRoute?: string
  hideTitle?: boolean
  isLogout?: boolean
  icon?: React.FC<React.SVGProps<SVGSVGElement>>
}

export const profileMenuLinks: IProfileMenuLinks[] = [
  { title: ProfileTabs.MENU, Component: ProfileMenu, hideTitle: true },
  { title: ProfileTabs.PROFILE, Component: PersonalInformation, icon: ProfileSVG },
  { title: ProfileTabs.BET_HISTORY, modalRoute: MODAL_ROUTE_URLS.CHOOSE_SPORT('betHistory'), icon: BetsHistorySVG },
  { title: ProfileTabs.SLOTS_HISTORY, Component: SlotsHistory, icon: SlotsHistorySVG },
  { title: ProfileTabs.BET_HISTORY2, Component: BetsHistory, hideTitle: true },
  { title: ProfileTabs.BONUSES, Component: ExchangeBonusToBalance, icon: TransferBonusSVG },
  { title: ProfileTabs.CHANGE_PASSWORD, Component: ChangePassword, icon: ChangePasswordSVG },
  { title: ProfileTabs.TRANSACTIONS, Component: Transactions, icon: TransactionVG },
  { title: ProfileTabs.LOGOUT, isLogout: true, icon: LogOutSVG },
]
